import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Box,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Stack,
    Button,
    Checkbox,
    Typography,
    FormControlLabel,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PrintIcon from "@mui/icons-material/Print";
import * as XLSX from "xlsx-js-style";
// import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
    freightList,
    freightComplete,
    freightDelete,
    updateFreight,
    freightPrint,
} from "../../../Services/Services";
import { branchpartyList } from "../../../Services/Services";
import { useEffect } from "react";
import Popover from "@mui/material/Popover";
import { Autocomplete } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
export default function NotRecFreight() {
    const [data, setData] = useState([]);
    const [partyFilter, setPartyFilter] = useState("");
    const [tpFilter, setTpFilter] = useState("");
    const [loadingDateFilter, setLoadingDateFilter] = useState(null);
    const [fromFilter, setFromFilter] = useState("");
    const [toBillingFilter, setToBillingFilter] = useState("");
    const [truckFilter, setTruckFilter] = useState("");
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editRow, setEditRow] = useState({});
    const [editIndex, setEditIndex] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorEl1, setAnchorEl1] = useState(null);
    const [settelement, setSetelement] = useState(null);
    const [deleteId, setDelete] = useState(null);
    const [partyOptions, setParties] = useState([]);
    const [branchOptions, setBranch] = useState([]);
    const [excelModalOpen, setExcelModalOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const fetchMoreParties = async (reset = false, filters = {}) => {
        try {
            // Permanent filter add करें
            const combinedFilters = {
                ...filters,
                freight_not_rec: "true"  // String value भेजें
            };

            const dataRes = await freightList(reset ? 1 : page, combinedFilters);

            if (dataRes?.results?.length) {
                setData((prev) =>
                    reset ? dataRes.results : [...prev, ...dataRes.results]
                );
                setPage((prev) => (reset ? 2 : prev + 1));
                setHasMore(!!dataRes.next);
            } else {
                if (reset) {
                    setData([]);
                    setPage(1);
                }
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching freight list:", error);
        }
    };

    // useEffect(() => {
    //   fetchMoreParties();
    // }, []);
    // useEffect(() => {
    //   const fetchBranchParties = async () => {
    //     const data = await branchpartyList();
    //     if (data) {
    //       setParties(data.party);
    //       setBranch(data.branch);
    //     }
    //   };
    //   fetchBranchParties();
    // }, []);

    // 1️⃣ Initial + Debounced filter load
    useEffect(() => {
        const handler = setTimeout(() => {
            fetchMoreParties(true, {
                party_name: partyFilter,
                do_no: tpFilter,
                ref_no: toBillingFilter,
                truck_no: truckFilter,
                loading_date: loadingDateFilter,
                from_to: fromFilter,
                freight_not_rec: true,
            });
        }, 500);

        return () => clearTimeout(handler);
    }, [
        partyFilter,
        tpFilter,
        toBillingFilter,
        truckFilter,
        loadingDateFilter,
        fromFilter,
    ]);

    // 2️⃣ Branch-party list (as it is)
    useEffect(() => {
        const fetchBranchParties = async () => {
            const data = await branchpartyList();
            if (data) {
                setParties(data.party);
                setBranch(data.branch);
            }
        };
        fetchBranchParties();
    }, []);

    const handleComplete = async (id) => {
        const complete_data = await freightComplete(id);
        setData((prevData) =>
            prevData.filter((row) => row.freight_id !== complete_data.freight_id)
        );
    };
    const handleDelete = async (id) => {
        const del_data = await freightDelete(id);
        setData((prevData) =>
            prevData.filter((row) => row.freight_id !== del_data.freight_id)
        );
    };
    const handleEditOpen = (row, index) => {
        setEditRow(row);
        setEditIndex(row.freight_id);
        setEditDialogOpen(true);
    };

    // const handleEditChange = (field, value) => {
    //   setEditRow({ ...editRow, [field]: value });
    // };

    const handleEditChange = (field, value) => {
        const updatedData = { ...editRow, [field]: value };

        const loading =
            parseFloat(field === "loading_wt" ? value : updatedData.loading_wt) || 0;
        const receiving =
            parseFloat(field === "received_wt" ? value : updatedData.received_wt) ||
            0;
        const freightRate =
            parseFloat(field === "freight_rate" ? value : updatedData.freight_rate) ||
            0;
        const tdsRate =
            parseFloat(field === "tds_per" ? value : updatedData.tds_per) || 0;
        const shortageRate =
            parseFloat(
                field === "shortage_rate" ? value : updatedData.shortage_rate
            ) || 0;
        const commission =
            parseFloat(field === "commission" ? value : updatedData.commission) || 0;
        const minesAdvance =
            parseFloat(field === "ad_mines_exp" ? value : updatedData.ad_mines_exp) ||
            0;
        const dieselAdvance =
            parseFloat(
                field === "ad_diesel_exp" ? value : updatedData.ad_diesel_exp
            ) || 0;
        const cashAdvance =
            parseFloat(field === "ad_cash_exp" ? value : updatedData.ad_cash_exp) ||
            0;
        const otherExp =
            parseFloat(field === "other_exp" ? value : updatedData.other_exp) || 0;

        // Billing Wt
        updatedData.billing_wt = Math.min(loading, receiving).toFixed(2);

        // Shortage Wt
        const shortage = (loading - receiving) * 1000;
        updatedData.shortage_wt = shortage > 0 ? shortage.toFixed(2) : "0";

        // Freight Amount
        const billing = parseFloat(updatedData.billing_wt) || 0;
        updatedData.freight_amt = (freightRate * billing).toFixed(2);

        // TDS Amount
        const tdsAmt = (parseFloat(updatedData.freight_amt) * tdsRate) / 100;
        updatedData.tds_amt = tdsAmt.toFixed(2);

        // Shortage Amount
        updatedData.shortage_amt = (
            parseFloat(updatedData.shortage_wt) * shortageRate
        ).toFixed(2);

        // Total Advance
        updatedData.total_advance = (
            minesAdvance +
            dieselAdvance +
            cashAdvance
        ).toFixed(2);

        // Net Amount
        updatedData.net_amount = (
            parseFloat(updatedData.freight_amt) -
            parseFloat(updatedData.tds_amt) -
            parseFloat(updatedData.shortage_amt) -
            parseFloat(updatedData.total_advance) -
            commission
        ).toFixed(2);

        // Net Payable
        updatedData.net_payable = (
            parseFloat(updatedData.net_amount) - otherExp
        ).toFixed(2);

        setEditRow(updatedData);
    };

    const handleEditSave = async () => {
        if (editRow.receive_amount === "") {
            editRow.receive_amount = 0;
        }

        editRow.bal_amount = (
            parseFloat(editRow.net_payable || 0) -
            parseFloat(editRow.paid_amount || 0)
        ).toFixed(2);
        const res_data = await updateFreight(editRow.freight_id, editRow);
        setData((prevData) =>
            prevData.map((row) =>
                row.freight_id === res_data.freight_id ? res_data : row
            )
        );

        setEditDialogOpen(false);
    };

    // Format date function (aapka existing wala)
    const formatDateYMD = (date) => {
        if (!(date instanceof Date)) return "";
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    };

    const selectedDate = loadingDateFilter
        ? formatDateYMD(loadingDateFilter)
        : "";
    const normalize = (str) => (str ?? "").toLowerCase().trim();

    const filteredData = data.filter((item) => {
        const normalize = (str) => (str ?? "").toLowerCase().trim();

        const fromValue = normalize(item.from_location);
        const toValue = normalize(item.to_location);
        const partyValue = normalize(item.party_name);
        const truckValue = normalize(item.truck_no);
        const refValue = item.billing?.billing_id?.toString() ?? "";
        const doValue = item.do_no?.toString() ?? "";

        const smartInput = normalize(fromFilter);
        const [fromPart, toPart] = smartInput.split("-").map((s) => s.trim());

        const fromMatches = fromPart ? fromValue.includes(fromPart) : true;
        const toMatches = toPart ? toValue.includes(toPart) : true;

        const looseMatch =
            !toPart &&
            (fromValue.includes(smartInput) || toValue.includes(smartInput));

        return (
            (partyFilter === "" || partyValue.includes(normalize(partyFilter))) &&
            (tpFilter === "" || doValue.includes(tpFilter)) &&
            (toBillingFilter === "" || refValue.includes(toBillingFilter)) &&
            (truckFilter === "" || truckValue.includes(normalize(truckFilter))) &&
            (selectedDate === "" || item.loading_date === selectedDate) &&
            ((fromPart && toPart && fromMatches && toMatches) ||
                (!toPart && looseMatch))
        );
    });

    const handleExportSelectedToExcel = () => {
        const selectedData = data.filter((row) =>
            selectedRows.includes(row.freight_id)
        );

        const exportData = selectedData.map((row) => ({
            "Party Name": row.party_name,
            "Branch Name": row.branch_name,
            "Loading Date": row.loading_date,
            "Unloading Date": row.unloading_date,
            "Truck No.": row.truck_no,
            "D.O. No.": row.do_no,
            "T.P. No.": row.tp_no,
            From: row.from_location,
            To: row.to_location,
            "Loading Wt": row.loading_wt,
            "Receiving Wt": row.received_wt,
            "Shortage Wt": row.shortage_wt,
            "Billing Wt": row.billing_wt,
            "Freight Rate": row.freight_rate,
            "Freight Amt": row.freight_amt,
            "TDS %": row.tds_per,
            "TDS Amt": row.tds_amt,
            "Shortage Rate": row.shortage_rate,
            "Shortage Amt": row.shortage_amt,
            "Ad Mines": row.ad_mines_exp,
            "Ad Diesel": row.ad_diesel_exp,
            "Ad Cash": row.ad_cash_exp,
            "Total Ad": row.total_advance,
            Commission: row.commission,
            "Net Amt": row.net_amount,
            "Others Exp.": row.other_exp,
            "Net Payable": row.net_payable,
            "Paid Amt": row.paid_amount,
            "Bal Amt": row.bal_amount,
            "Rec Amt": row.receive_amount,
            "Diff Amt": row.difference_amount,
            "Payment Remark": row.payment_remark,
            "Ref. No": row.billing
                ? `${row.billing.branch_name === "RAIPUR"
                    ? "SRE"
                    : row.billing.branch_name === "BILASPUR"
                        ? "JHT"
                        : "MBR"
                }/${row.billing.billing_id}/${getInitials(row.billing.party_name)}`
                : "",
            "Bill Date": row.billing ? formatOnlyDate(row.billing.created_at) : "",
            "Truck Owner": row.truck_owner,
            "Phone No.": row.phone_no,
            "PAN No.": row.pan_no,
            Remark: row.remark,
            Date: formatOnlyDate(row.created_at),
        }));

        const ws_data = [
            Object.keys(exportData[0]),
            ...exportData.map((obj) => Object.values(obj)),
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(ws_data);

        // 🔸 Auto-fit column widths
        const colWidths = ws_data[0].map((_, colIndex) => {
            const maxLength = ws_data.reduce((max, row) => {
                const cell = row[colIndex];
                const len = cell ? cell.toString().length : 10;
                return Math.max(max, len);
            }, 10);
            return { wch: maxLength + 2 };
        });
        worksheet["!cols"] = colWidths;

        // 🔸 Black border style
        const blackBorder = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
        };

        // 🔸 Style header row
        const headerLength = ws_data[0].length;
        for (let c = 0; c < headerLength; c++) {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c })];
            if (cell) {
                cell.s = {
                    fill: { fgColor: { rgb: "FFFF99" } },
                    font: { bold: true, color: { rgb: "000000" } },
                    alignment: { horizontal: "center", vertical: "center" },
                    border: blackBorder,
                };
            }
        }

        // 🔸 Style data cells
        for (let r = 1; r < ws_data.length; r++) {
            for (let c = 0; c < headerLength; c++) {
                const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
                if (cell) {
                    cell.s = {
                        alignment: { horizontal: "center", vertical: "center" },
                        border: blackBorder,
                    };
                }
            }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Freight Report");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
            cellStyles: true,
        });

        const file = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });

        saveAs(file, "Selected_Freight_Report.xlsx");

        setExcelModalOpen(false);
        setSelectedRows([]);
    };

    function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
        const date = new Date(dateTimeString);

        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();

        if (format === "dd-mm-yyyy") {
            return `${day}-${month}-${year}`;
        } else if (format === "yyyy-mm-dd") {
            return `${year}-${month}-${day}`;
        } else {
            throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
        }
    }
    const handlePrintSingleRow = async (row) => {
        const data = await freightPrint(row.freight_id);

        const printWindow = window.open("", "", "width=900,height=600");

        const fieldPairs = [
            ["loading_date", "unloading_date"],
            ["from_location", "to_location"],
            ["do_no", "tp_no"],
            ["loading_wt", "received_wt"],
            ["shortage_wt", "billing_wt"],
            ["freight_rate", "freight_amt"],
            ["tds_per", "tds_amt"],
            ["total_advance", "commission"],
            ["shortage_rate", "shortage_amt"],
            ["net_amount", "other_exp"],
            ["net_payable", "truck_no"],
        ];
        row.payments = data[0] ? data[0].payments : [];
        row.freights = data[0] ? data[0].freights : [];
        const tableRows = fieldPairs.map(([key1, key2]) => {
            const value1 = row[key1] ?? "";
            const value2 = row[key2] ?? "";

            const formatTitle = (text) =>
                text
                    .replace(/_/g, " ")
                    .replace(
                        /\w\S*/g,
                        (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
                    );

            const tdStyle = (hasKey) =>
                hasKey
                    ? 'style="border:1px solid #000;padding:6px;width:22%;background-color:rgba(211, 211, 211, 0.42);"'
                    : 'style="border:1px solid #000;padding:6px;width:22%;"';

            return `
      <tr>
        <td ${tdStyle(!!key1)}><strong>${key1 ? formatTitle(key1) : ""
                }</strong></td>
        <td style="border:1px solid #000;padding:6px;width:28%;">${value1}</td>
        <td style="width:2%;"></td>
        <td ${tdStyle(!!key2)}><strong>${key2 ? formatTitle(key2) : ""
                }</strong></td>
        <td style="border:1px solid #000;padding:6px;width:28%;">${value2}</td>
      </tr>
    `;
        });

        // Generate additional table with heading and multiple payment entries
        let additionalTableHTML = "";

        if (Array.isArray(row.freights) && row.freights.length > 0) {
            additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Freight Id</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Truck No</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Load Wt</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Unload Wt </th>
        <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Net Payble</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Date</th>
        </tr>
      </thead>
      <tbody>
  `;

            row.freights.forEach((freight) => {
                additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${freight.freight_id || ""}</td>
                <td style="text-align:center;">${freight.truck_no || ""}</td>
        <td style="text-align:center;">${freight.loading_wt || ""}</td>
        <td style="text-align:center;">${freight.received_wt || ""}</td>
        <td style="text-align:center;">${freight.net_payable || ""}</td>
         <td style="text-align:center;">${formatOnlyDate(freight.created_at) || ""
                    }</td>
      </tr>
    `;
            });

            additionalTableHTML += `
      </tbody>
    </table>
  `;
        }

        // If multiple payments exist

        if (Array.isArray(row.payments) && row.payments.length > 0) {
            additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Paid Amt</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Pay Mode</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">UPI/Cheque No.</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Payment To</th>
        <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Remark</th>
          </tr>
      </thead>
      <tbody>
  `;

            row.payments.forEach((payment) => {
                additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${payment.pay_amount || ""}</td>
        <td style="text-align:center;">${payment.pay_mode || ""}</td>
        <td style="text-align:center;">${payment.upi_check_no || ""}</td>
        <td style="text-align:center;">${payment.payment_to || ""}</td>
         <td style="text-align:center;">${payment.remark || ""}</td>
      </tr>
    `;
            });

            additionalTableHTML += `
      </tbody>
    </table>
  `;
        }

        if (Array.isArray(data) && data.length > 0) {
            additionalTableHTML += `
    <table border="1" style="border-collapse: collapse; width: 100%; margin-top: 20px;" cellpadding="5">
      <thead>
        <tr>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Total Amount</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Paid Amount</th>
          <th style="background-color: rgba(211, 211, 211, 0.42); -webkit-print-color-adjust: exact; print-color-adjust: exact;">Balance Amount</th>
          </tr>
      </thead>
      <tbody>
  `;

            data.forEach((payment) => {
                additionalTableHTML += `
      <tr>
        <td style="text-align:center;">${payment.total_amount || ""}</td>
        <td style="text-align:center;">${payment.paid_amount || ""}</td>
        <td style="text-align:center;">${payment.rem_amount || ""}</td>
      </tr>
    `;
            });

            additionalTableHTML += `
      </tbody>
    </table>
  `;
        }
        printWindow.document.write(`
    <html>
      <head>
        <title>Print Freight Row</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          header {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 20px;
            color: #333;
          }
          footer {
            position: fixed;
            bottom: 10px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          td {
            font-size: 14px;
            vertical-align: top;
          }
          th {
            background-color:rgba(211, 211, 211, 0.42);
            font-weight: bold;
          }
          td[style*="background-color"], th[style*="background-color"] {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        </style>
      </head>
      <body>
        <header>SR ENTERPRICES</header>

        <table border="1" style="border: 1px solid black; border-collapse: collapse;" cellpadding="5">
          <tr>
            <td>Ashutosh Ku. Singh</td>
            <td>Freight ID: ${row.freight_id}</td>
            <td>${row.truck_owner}</td>
          </tr>
          <tr>
            <td>Branch Name: ${row.branch_name}</td>
            <td>Net Payable : ${row.net_payable}</td>
            <td>${row.phone_no}</td>
          </tr>
        </table>

        <br>

        <table>
          ${tableRows.join("")}
        </table>

        <table border="1" style="border-collapse: collapse; width: 100%;" cellpadding="5">
          <tbody>
            ${additionalTableHTML}
          </tbody>
        </table>

        <footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>

        <script>
          window.onload = function () {
            window.print();
            window.onafterprint = function () {
              window.close();
            };
          };
        </script>
      </body>
    </html>
  `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setEditRow((prev) => ({
            ...prev,
            is_remember: checked,
        }));
    };

    const getInitials = (str) => {
        return str
            .split(" ")
            .filter((word) => word)
            .map((word) => word[0])
            .join("")
            .toUpperCase();
    };
    return (
        <div style={{ maxHeight: "calc(100vh - 70px)", }}>
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    mb: 2,
                    p: 2,
                }}
            >
                <TextField
                    fullWidth
                    label="Filter by Party Name"
                    variant="outlined"
                    size="small"
                    value={partyFilter}
                    onChange={(e) => setPartyFilter(e.target.value)}
                    sx={{ flex: "1 1 200px", marginTop: -4 }}
                />
                <TextField
                    fullWidth
                    label="Do No"
                    variant="outlined"
                    size="small"
                    value={tpFilter}
                    onChange={(e) => setTpFilter(e.target.value)}
                    sx={{ flex: "1 1 100px", marginTop: -4 }}
                />
                <TextField
                    fullWidth
                    label="Ref No"
                    variant="outlined"
                    size="small"
                    value={toBillingFilter}
                    onChange={(e) => setToBillingFilter(e.target.value)}
                    sx={{ flex: "1 1 100px", marginTop: -4 }}
                />
                <TextField
                    fullWidth
                    label=" Truck No"
                    variant="outlined"
                    size="small"
                    value={truckFilter}
                    onChange={(e) => setTruckFilter(e.target.value)}
                    sx={{ flex: "1 1 100px", marginTop: -4 }}
                />
                <TextField
                    fullWidth
                    label="Filter by loading date"
                    type="date"
                    name="Filter by loading date"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    size="small"
                    value={
                        loadingDateFilter
                            ? loadingDateFilter.toISOString().split("T")[0]
                            : ""
                    }
                    onChange={(e) =>
                        setLoadingDateFilter(
                            e.target.value ? new Date(e.target.value) : null
                        )
                    }
                    sx={{ flex: "1 1 150px", marginTop: -4 }}
                />

                <TextField
                    fullWidth
                    label="Filter by From - To"
                    name="from"
                    variant="outlined"
                    size="small"
                    value={fromFilter}
                    onChange={(e) => setFromFilter(e.target.value)}
                    sx={{ flex: "1 1 200px", marginTop: -4 }}
                />

                <Button
                    variant="outlined"
                    // onClick={handleExportExcel}
                    onClick={() => setExcelModalOpen(true)}
                    sx={{ minWidth: "40px", height: "40px", padding: 0, marginTop: -4 }}
                >
                    <FileDownloadIcon fontSize="small" />
                </Button>
            </Box>
            {/* <div
        style={{
          position: "sticky",
          top: 70,
          maxHeight: "75vh",
          overflow: "auto",
        }}
      > */}
            <InfiniteScroll
                dataLength={data.length}
                next={fetchMoreParties}
                hasMore={hasMore}
                scrollableTarget="freight-list"
                scrollThreshold={0.8}
            // loader={<h4 style={{ textAlign: "center" }}>Loading...</h4>}
            >
                <TableContainer
                    id="freight-list"
                    sx={{
                        maxHeight: "75vh", // allows vertical scroll
                        overflow: "auto",
                    }}
                >
                    <Table
                        stickyHeader // ✅ THIS makes the header sticky
                        size="small"
                        sx={{
                            tableLayout: "auto",
                            width: "auto",
                            "& td, & th": {
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                padding: "4px 8px",
                                fontSize: "0.8125rem",
                                borderBottom: "1px solid #ccc",
                            },
                        }}
                    >
                        <TableHead>
                            <TableRow
                                sx={{
                                    "& th": {
                                        fontWeight: "bold",
                                        color: (theme) =>
                                            theme.palette.mode === "dark" ? "#2196f3" : "#333",
                                        backgroundColor: (theme) =>
                                            theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                                    },
                                }}
                            >
                                <TableCell
                                    className="no-export"
                                    sx={{
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 3,
                                    }}
                                >
                                    Settle{" "}
                                </TableCell>
                                <TableCell
                                    sx={{
                                        position: "sticky",
                                        left: 40,
                                        zIndex: 3,
                                    }}
                                >
                                    SR. No
                                </TableCell>
                                <TableCell
                                    sx={{
                                        position: "sticky",
                                        left: 100,
                                        zIndex: 3,
                                    }}
                                >
                                    Truck No.
                                </TableCell>
                                <TableCell>Freight Id</TableCell>

                                <TableCell>Party Name</TableCell>
                                <TableCell>Branch Name</TableCell>
                                <TableCell>Loading Date</TableCell>
                                <TableCell>Unloading Date</TableCell>

                                <TableCell>D.O. No.</TableCell>
                                <TableCell className="no-print">T.P. No.</TableCell>
                                <TableCell>From</TableCell>
                                <TableCell>To</TableCell>
                                <TableCell>Loading Wt</TableCell>
                                <TableCell>Receiving Wt</TableCell>
                                <TableCell>Shortage Wt</TableCell>
                                <TableCell>Billing Wt</TableCell>
                                <TableCell>Freight Rate</TableCell>
                                <TableCell>Freight Amt</TableCell>
                                <TableCell className="no-print">TDS %</TableCell>
                                <TableCell>TDS Amt</TableCell>
                                <TableCell>Shortage Rate</TableCell>
                                <TableCell>Shortage Amt</TableCell>
                                <TableCell className="no-print">Ad Mines</TableCell>
                                <TableCell className="no-print">Ad Diesel</TableCell>
                                <TableCell className="no-print">Ad Cash</TableCell>
                                <TableCell>Total Ad</TableCell>
                                <TableCell>Commission</TableCell>
                                <TableCell>Net Amt</TableCell>
                                <TableCell>Others Exp.</TableCell>
                                <TableCell>Net Payable</TableCell>
                                {/* I Copied This Part */}
                                <TableCell>Paid Amt</TableCell>
                                <TableCell>Bal Amt</TableCell>
                                <TableCell>Ref. No</TableCell>
                                <TableCell>Pay Id</TableCell>
                                <TableCell>Biil Date</TableCell>
                                <TableCell className="no-print">Truck Owner</TableCell>
                                <TableCell className="no-print">Phone No.</TableCell>
                                <TableCell className="no-print">PAN No.</TableCell>
                                <TableCell className="no-print">Remark</TableCell>
                                {/* This Part Is Copied */}
                                <TableCell>Rec Amt</TableCell>
                                <TableCell>Diff Amt</TableCell>
                                <TableCell>Payment Remark</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell
                                    className="no-print"
                                    sx={{
                                        position: "sticky",
                                        right: 0,
                                        backgroundColor: "#f5f5f5",
                                        zIndex: 2,
                                    }}
                                >
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={32} align="center">
                                        No matching records found.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                filteredData.map((row, index) => {
                                    const createdDate = new Date(row.created_at);
                                    const today = new Date();
                                    const diffInDays = (today - createdDate) / (1000 * 3600 * 24);
                                    const isOlderThan10Days = diffInDays > 10;
                                    const isUnpaid =
                                        !row.paid_amount || Number(row.paid_amount) === 0;
                                    const isOverdue = isOlderThan10Days && isUnpaid;

                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                backgroundColor: row.is_completed
                                                    ? "#c8e6c9" // light green for completed
                                                    : isOverdue
                                                        ? "#ffcdd2"
                                                        : row.is_remember
                                                            ? "#ffe0b2"
                                                            : index % 2 === 0
                                                                ? "#fafafa"
                                                                : "#ffffff",
                                                "& td": {
                                                    color: (theme) =>
                                                        theme.palette.mode === "dark" ? "white" : "inherit",
                                                    backgroundColor: row.is_completed
                                                        ? "#c8e6c9"
                                                        : isOverdue
                                                            ? "#ffcdd2"
                                                            : row.is_remember
                                                                ? "#ffe0b2"
                                                                : (theme) =>
                                                                    theme.palette.mode === "dark"
                                                                        ? "black"
                                                                        : "inherit",
                                                },
                                            }}
                                        >
                                            <TableCell
                                                className="no-export"
                                                sx={{ position: "sticky", left: 0 }}
                                                padding="checkbox"
                                            >
                                                <Checkbox
                                                    size="small"
                                                    onClick={(e) => {
                                                        setAnchorEl(e.currentTarget);
                                                        setSetelement(row.freight_id);
                                                    }}
                                                    disabled={row.is_completed}
                                                />
                                            </TableCell>

                                            <TableCell sx={{ position: "sticky", left: 40 }}>
                                                {index + 1}
                                            </TableCell>
                                            <TableCell sx={{ position: "sticky", left: 100 }}>
                                                {row.truck_no}
                                            </TableCell>
                                            <TableCell>{row.freight_id}</TableCell>

                                            <TableCell>{row.party_name}</TableCell>
                                            <TableCell>{row.branch_name}</TableCell>
                                            <TableCell>{row.loading_date}</TableCell>
                                            <TableCell>{row.unloading_date}</TableCell>

                                            <TableCell>{row.do_no}</TableCell>
                                            <TableCell className="no-print">{row.tp_no}</TableCell>
                                            <TableCell>{row.from_location}</TableCell>
                                            <TableCell>{row.to_location}</TableCell>
                                            <TableCell>{row.loading_wt}</TableCell>
                                            <TableCell>{row.received_wt}</TableCell>
                                            <TableCell>{row.shortage_wt}</TableCell>
                                            <TableCell>{row.billing_wt}</TableCell>
                                            <TableCell>{row.freight_rate}</TableCell>
                                            <TableCell>{row.freight_amt}</TableCell>
                                            <TableCell className="no-print">{row.tds_per}</TableCell>
                                            <TableCell>{row.tds_amt}</TableCell>
                                            <TableCell>{row.shortage_rate}</TableCell>
                                            <TableCell>{row.shortage_amt}</TableCell>
                                            <TableCell className="no-print">
                                                {row.ad_mines_exp}
                                            </TableCell>
                                            <TableCell className="no-print">
                                                {row.ad_diesel_exp}
                                            </TableCell>
                                            <TableCell className="no-print">
                                                {row.ad_cash_exp}
                                            </TableCell>
                                            <TableCell>{row.total_advance}</TableCell>
                                            <TableCell>{row.commission}</TableCell>
                                            <TableCell>{row.net_amount}</TableCell>

                                            <TableCell>{row.other_exp}</TableCell>
                                            <TableCell>{row.net_payable}</TableCell>
                                            {/* I Copied This 4  */}
                                            <TableCell>{row.paid_amount.toFixed(1)}</TableCell>
                                            <TableCell>{row.bal_amount.toFixed(1)}</TableCell>
                                            <TableCell>
                                                {row.billing ? (
                                                    <>
                                                        {row.billing.branch_name === "RAIPUR"
                                                            ? "SRE"
                                                            : row.billing.branch_name === "BILASPUR"
                                                                ? "JHT"
                                                                : "MBR"}
                                                        /{row.billing.billing_id}/
                                                        {getInitials(row.billing.party_name)}
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                            </TableCell>

                                            <TableCell>
                                                {row.freight_pay_ids && row.freight_pay_ids.length > 0
                                                    ? row.freight_pay_ids.join(", ")
                                                    : ""}
                                            </TableCell>

                                            <TableCell>
                                                {row.billing
                                                    ? formatOnlyDate(row.billing.created_at)
                                                    : ""}
                                            </TableCell>

                                            <TableCell className="no-print">
                                                {row.truck_owner}
                                            </TableCell>
                                            <TableCell className="no-print">{row.phone_no}</TableCell>
                                            <TableCell className="no-print">{row.pan_no}</TableCell>
                                            <TableCell className="no-print">{row.remark}</TableCell>
                                            {/* This Part I copied */}
                                            <TableCell className="no-print">
                                                {row.receive_amount.toFixed(1)}
                                            </TableCell>
                                            <TableCell className="no-print">
                                                {row.difference_amount.toFixed(1)}
                                            </TableCell>
                                            <TableCell className="no-print">
                                                {row.payment_remark}
                                            </TableCell>
                                            <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                                            <TableCell
                                                className="no-print"
                                                sx={{
                                                    position: "sticky",
                                                    right: 0,
                                                    backgroundColor: "#fff",
                                                    zIndex: 1,
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    justifyContent="center"
                                                >
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => handleEditOpen(row, row.freight_id)}
                                                    >
                                                        <Edit fontSize="small" />
                                                    </IconButton>

                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={(event) => {
                                                            setAnchorEl1(event.currentTarget);
                                                            setDelete(row.freight_id);
                                                        }}
                                                    >
                                                        <Delete fontSize="small" />
                                                    </IconButton>

                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => handlePrintSingleRow(row)}
                                                    >
                                                        <PrintIcon fontSize="small" />
                                                    </IconButton>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            )}
                        </TableBody>

                        <TableRow
                            sx={{
                                backgroundColor: "#e3f2fd",
                                fontWeight: "bold",
                            }}
                        >
                            <TableCell colSpan={12} align="right">
                                Total:
                            </TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.loading_wt || 0),
                                        0
                                    )
                                    .toFixed(3)}
                            </TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.received_wt || 0),
                                        0
                                    )
                                    .toFixed(3)}
                            </TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.shortage_wt || 0),
                                        0
                                    )
                                    .toFixed(3)}
                            </TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.billing_wt || 0),
                                        0
                                    )
                                    .toFixed(3)}
                            </TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.freight_amt || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>
                            <TableCell align="center"></TableCell>

                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.tds_amt || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.shortage_amt || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>
                            <TableCell align="center" colSpan={2}></TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.total_advance || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.commission || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.net_amount || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.other_exp || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>
                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.net_payable || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>

                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.paid_amount || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>

                            <TableCell align="center">
                                {filteredData
                                    .reduce(
                                        (accumulator, currentValue) =>
                                            accumulator + (+currentValue.bal_amount || 0),
                                        0
                                    )
                                    .toFixed(1)}
                            </TableCell>
                            <TableCell align="center" colSpan={11}></TableCell>
                        </TableRow>
                    </Table>
                </TableContainer>
            </InfiniteScroll>
            {/* </div> */}

            <Dialog
                open={editDialogOpen}
                onClose={() => setEditDialogOpen(false)}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>Edit Freight Record</DialogTitle>

                <DialogContent>
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={2}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={editRow.is_remember || false}
                                        onChange={handleCheckboxChange}
                                    />
                                }
                                label="Remember"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={editRow.is_not_rec || false}
                                        onChange={(e) =>
                                            handleEditChange("is_not_rec", e.target.checked)
                                        }
                                    />
                                }
                                label="Freight Not Received"
                            />
                        </Stack>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={3}>
                            <Autocomplete
                                options={partyOptions}
                                getOptionLabel={(option) => option?.name || ""}
                                value={
                                    partyOptions.find((opt) => opt.name === editRow.party_name) ||
                                    null
                                }
                                onChange={(event, newValue) => {
                                    handleEditChange("party_id", newValue?.party_id || "");
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Party Name"
                                        variant="outlined"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <Autocomplete
                                options={branchOptions}
                                getOptionLabel={(option) => option?.branch_name || ""}
                                value={
                                    branchOptions.find(
                                        (opt) => opt.branch_name === editRow.branch_name
                                    ) || null
                                }
                                onChange={(event, newValue) => {
                                    handleEditChange("branch_id", newValue?.branch_id || "");
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Branch Name"
                                        variant="outlined"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                label="From Location"
                                fullWidth
                                value={editRow.from_location || ""}
                                onChange={(e) =>
                                    handleEditChange("from_location", e.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="To Location"
                                fullWidth
                                value={editRow.to_location || ""}
                                onChange={(e) =>
                                    handleEditChange("to_location", e.target.value)
                                }
                            />
                        </Grid>

                        {/* 2nd Row */}
                        <Grid item xs={3}>
                            <TextField
                                label="Loading Date"
                                type="date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={editRow.loading_date || ""}
                                onChange={(e) =>
                                    handleEditChange("loading_date", e.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Unloading Date"
                                type="date"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={editRow.unloading_date || ""}
                                onChange={(e) =>
                                    handleEditChange("unloading_date", e.target.value)
                                }
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                label="Truck No"
                                fullWidth
                                value={editRow.truck_no || ""}
                                onChange={(e) => handleEditChange("truck_no", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Truck Owner"
                                fullWidth
                                value={editRow.truck_owner || ""}
                                onChange={(e) =>
                                    handleEditChange("truck_owner", e.target.value)
                                }
                            />
                        </Grid>

                        {/* 3rd Row */}
                        <Grid item xs={3}>
                            <TextField
                                label="Phone No."
                                fullWidth
                                value={editRow.phone_no || ""}
                                onChange={(e) => handleEditChange("phone_no", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="PAN No"
                                fullWidth
                                value={editRow.pan_no || ""}
                                onChange={(e) => handleEditChange("pan_no", e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                label="TP No"
                                fullWidth
                                value={editRow.tp_no || ""}
                                onChange={(e) => handleEditChange("tp_no", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="DO No"
                                fullWidth
                                value={editRow.do_no || ""}
                                onChange={(e) => handleEditChange("do_no", e.target.value)}
                            />
                        </Grid>

                        {/* 4th Row */}
                        <Grid item xs={3}>
                            <TextField
                                label="Loading Wt"
                                fullWidth
                                value={editRow.loading_wt || ""}
                                onChange={(e) => handleEditChange("loading_wt", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Receiving Wt"
                                fullWidth
                                value={editRow.received_wt || ""}
                                onChange={(e) =>
                                    handleEditChange("received_wt", e.target.value)
                                }
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                label="Shortage Wt"
                                fullWidth
                                value={editRow.shortage_wt || ""}
                                onChange={(e) =>
                                    handleEditChange("shortage_wt", e.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Billing Wt"
                                fullWidth
                                value={editRow.billing_wt || ""}
                                onChange={(e) => handleEditChange("billing_wt", e.target.value)}
                            />
                        </Grid>

                        {/* 5th Row */}
                        <Grid item xs={3}>
                            <TextField
                                label="Freight Rate"
                                fullWidth
                                value={editRow.freight_rate || ""}
                                onChange={(e) =>
                                    handleEditChange("freight_rate", e.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Freight Amount"
                                fullWidth
                                value={editRow.freight_amt || ""}
                                onChange={(e) =>
                                    handleEditChange("freight_amt", e.target.value)
                                }
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                label="Shortage Rate"
                                fullWidth
                                value={editRow.shortage_rate || ""}
                                onChange={(e) =>
                                    handleEditChange("shortage_rate", e.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Shortage Amount"
                                fullWidth
                                value={editRow.shortage_amt || ""}
                                onChange={(e) =>
                                    handleEditChange("shortage_amt", e.target.value)
                                }
                            />
                        </Grid>

                        {/* 6th Row */}
                        <Grid item xs={3}>
                            <TextField
                                label="TDS (%)"
                                fullWidth
                                value={editRow.tds_per || ""}
                                onChange={(e) => handleEditChange("tds_per", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="TDS Amount"
                                fullWidth
                                value={editRow.tds_amt || ""}
                                onChange={(e) => handleEditChange("tds_amt", e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                label="Ad Mines"
                                fullWidth
                                value={editRow.ad_mines_exp || ""}
                                onChange={(e) =>
                                    handleEditChange("ad_mines_exp", e.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Ad Diesel"
                                fullWidth
                                value={editRow.ad_diesel_exp || ""}
                                onChange={(e) =>
                                    handleEditChange("ad_diesel_exp", e.target.value)
                                }
                            />
                        </Grid>

                        {/* 7th Row */}
                        <Grid item xs={3}>
                            <TextField
                                label="Ad Cash"
                                fullWidth
                                value={editRow.ad_cash_exp || ""}
                                onChange={(e) =>
                                    handleEditChange("ad_cash_exp", e.target.value)
                                }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Total Advance"
                                fullWidth
                                value={editRow.total_advance || ""}
                                onChange={(e) =>
                                    handleEditChange("total_advance", e.target.value)
                                }
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                label="Commission"
                                fullWidth
                                value={editRow.commission || ""}
                                onChange={(e) => handleEditChange("commission", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Net Amount"
                                fullWidth
                                value={editRow.net_amount || ""}
                                onChange={(e) => handleEditChange("net_amount", e.target.value)}
                            />
                        </Grid>

                        {/* 8th Row */}
                        <Grid item xs={3}>
                            <TextField
                                label="Others Exp."
                                fullWidth
                                value={editRow.other_exp || ""}
                                onChange={(e) => handleEditChange("other_exp", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Net Payable"
                                fullWidth
                                value={editRow.net_payable || ""}
                                onChange={(e) =>
                                    handleEditChange("net_payable", e.target.value)
                                }
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                                label="Remark"
                                fullWidth
                                value={editRow.remark || ""}
                                onChange={(e) => handleEditChange("remark", e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField
                                label="Hisab Amount"
                                fullWidth
                                type="number"
                                value={editRow.receive_amount || 0}
                                onChange={(e) =>
                                    handleEditChange("receive_amount", e.target.value)
                                }
                                disabled={!editRow.is_bill}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label="Difference Amount"
                                fullWidth
                                value={
                                    (editRow.net_amount - editRow.receive_amount).toFixed(2) || ""
                                }
                                onChange={(e) =>
                                    handleEditChange("difference_amount", e.target.value)
                                }
                                disabled
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField
                                label="Remark for Payment"
                                fullWidth
                                value={editRow.payment_remark || ""}
                                onChange={(e) =>
                                    handleEditChange("payment_remark", e.target.value)
                                }
                                disabled={!editRow.is_bill}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleEditSave}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => {
                    setAnchorEl(null);
                    setSetelement(null);
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Box sx={{ p: 1 }}>
                    <Typography variant="body2">Are you sure Setelement ?</Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                        <Button
                            color="error"
                            size="small"
                            onClick={async () => {
                                try {
                                    await handleComplete(settelement);
                                } finally {
                                    setAnchorEl(null);
                                    setSetelement(null);
                                }
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            size="small"
                            onClick={() => {
                                setAnchorEl(null);
                                setSetelement(null);
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </Box>
            </Popover>

            <Popover
                open={Boolean(anchorEl1)}
                anchorEl={anchorEl1}
                onClose={() => {
                    setAnchorEl1(null);
                    setDelete(null);
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Box sx={{ p: 1 }}>
                    <Typography variant="body2">Are you sure ?</Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                        <Button
                            color="error"
                            size="small"
                            onClick={async () => {
                                try {
                                    await handleDelete(deleteId);
                                } finally {
                                    setAnchorEl1(null);
                                    setDelete(null);
                                }
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            size="small"
                            onClick={() => {
                                setAnchorEl1(null);
                                setDelete(null);
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </Box>
            </Popover>

            <Dialog
                open={excelModalOpen}
                onClose={() => setExcelModalOpen(false)}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>Select Rows for Excel Export</DialogTitle>
                <DialogContent>
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 1,
                            mb: 2,
                            mt: 1,
                            justifyContent: "center",
                        }}
                    >
                        <TextField
                            fullWidth
                            label="Filter by Party Name"
                            variant="outlined"
                            size="small"
                            value={partyFilter}
                            onChange={(e) => setPartyFilter(e.target.value)}
                            sx={{ flex: "1 1 200px" }}
                        />
                        <TextField
                            fullWidth
                            label="Do No"
                            variant="outlined"
                            size="small"
                            value={tpFilter}
                            onChange={(e) => setTpFilter(e.target.value)}
                            sx={{ flex: "1 1 100px" }}
                        />
                        <TextField
                            fullWidth
                            label="Ref No"
                            variant="outlined"
                            size="small"
                            value={toBillingFilter}
                            onChange={(e) => setToBillingFilter(e.target.value)}
                            sx={{ flex: "1 1 100px" }}
                        />
                        <TextField
                            fullWidth
                            label=" Truck No"
                            variant="outlined"
                            size="small"
                            value={truckFilter}
                            onChange={(e) => setTruckFilter(e.target.value)}
                            sx={{ flex: "1 1 100px" }}
                        />
                        <TextField
                            fullWidth
                            label="Filter by loading date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            size="small"
                            value={
                                loadingDateFilter
                                    ? loadingDateFilter.toISOString().split("T")[0]
                                    : ""
                            }
                            onChange={(e) =>
                                setLoadingDateFilter(
                                    e.target.value ? new Date(e.target.value) : null
                                )
                            }
                            sx={{ flex: "1 1 150px" }}
                        />
                        <TextField
                            fullWidth
                            label="Filter by From - To"
                            name="from"
                            variant="outlined"
                            size="small"
                            value={fromFilter}
                            onChange={(e) => setFromFilter(e.target.value)}
                            sx={{ flex: "1 1 200px" }}
                        />
                    </Box>

                    <TableContainer
                        id="modal-freight-table"
                        sx={{
                            maxHeight: "60vh",
                            overflow: "auto",
                        }}
                    >
                        <Table
                            stickyHeader
                            size="small"
                            sx={{
                                tableLayout: "auto",
                                width: "auto",
                                "& td, & th": {
                                    textAlign: "center",
                                    whiteSpace: "nowrap",
                                    padding: "4px 8px",
                                    fontSize: "0.8125rem",
                                    borderBottom: "1px solid #ccc",
                                },
                            }}
                        >
                            <TableHead>
                                <TableRow
                                    sx={{
                                        "& th": {
                                            fontWeight: "bold",
                                            color: (theme) =>
                                                theme.palette.mode === "dark" ? "#2196f3" : "#333",
                                            backgroundColor: (theme) =>
                                                theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                                        },
                                    }}
                                >
                                    <TableCell padding="checkbox">
                                        {/* <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      size="small"
                    /> */}
                                    </TableCell>
                                    <TableCell>Freight ID</TableCell>
                                    <TableCell>Truck No</TableCell>
                                    <TableCell>Party Name</TableCell>
                                    <TableCell>Branch Name</TableCell>
                                    <TableCell>Loading Date</TableCell>
                                    <TableCell>Unloading Date</TableCell>

                                    <TableCell>D.O. No.</TableCell>
                                    <TableCell>T.P. No.</TableCell>
                                    <TableCell>From</TableCell>
                                    <TableCell>To</TableCell>
                                    <TableCell>Loading Wt</TableCell>
                                    <TableCell>Receiving Wt</TableCell>
                                    <TableCell>Shortage Wt</TableCell>
                                    <TableCell>Billing Wt</TableCell>
                                    <TableCell>Freight Rate</TableCell>
                                    <TableCell>Freight Amt</TableCell>
                                    <TableCell>TDS %</TableCell>
                                    <TableCell>TDS Amt</TableCell>
                                    <TableCell>Shortage Rate</TableCell>
                                    <TableCell>Shortage Amt</TableCell>
                                    <TableCell>Ad Mines</TableCell>
                                    <TableCell>Ad Diesel</TableCell>
                                    <TableCell>Ad Cash</TableCell>
                                    <TableCell>Total Ad</TableCell>
                                    <TableCell>Commission</TableCell>
                                    <TableCell>Net Amt</TableCell>
                                    <TableCell>Others Exp.</TableCell>
                                    <TableCell>Net Payable</TableCell>
                                    <TableCell>Paid Amt</TableCell>
                                    <TableCell>Bal Amt</TableCell>
                                    <TableCell>Ref. No</TableCell>
                                    <TableCell>Biil Date</TableCell>
                                    <TableCell>Truck Owner</TableCell>
                                    <TableCell>Phone No.</TableCell>
                                    <TableCell>PAN No.</TableCell>
                                    <TableCell>Remark</TableCell>
                                    <TableCell>Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData
                                    .filter((row) =>
                                        row.party_name
                                            .toLowerCase()
                                            .includes(searchQuery.toLowerCase())
                                    )
                                    .map((row) => (
                                        <TableRow
                                            key={row.freight_id}
                                            sx={{
                                                backgroundColor: row.is_completed
                                                    ? "#c8e6c9"
                                                    : row.paid_amount === 0
                                                        ? "#ffcdd2"
                                                        : "#ffffff",
                                                "& td": {
                                                    color: (theme) =>
                                                        theme.palette.mode === "dark" ? "white" : "inherit",
                                                    backgroundColor: row.is_completed
                                                        ? "#c8e6c9"
                                                        : row.paid_amount === 0
                                                            ? "#ffcdd2"
                                                            : (theme) =>
                                                                theme.palette.mode === "dark"
                                                                    ? "black"
                                                                    : "inherit",
                                                },
                                            }}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    size="small"
                                                    checked={selectedRows.includes(row.freight_id)}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setSelectedRows((prev) =>
                                                            checked
                                                                ? [...prev, row.freight_id]
                                                                : prev.filter((id) => id !== row.freight_id)
                                                        );
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell>{row.freight_id}</TableCell>
                                            <TableCell>{row.truck_no}</TableCell>
                                            <TableCell>{row.party_name}</TableCell>
                                            <TableCell>{row.branch_name}</TableCell>
                                            <TableCell>{row.loading_date}</TableCell>
                                            <TableCell>{row.unloading_date}</TableCell>
                                            <TableCell>{row.do_no}</TableCell>
                                            <TableCell>{row.tp_no}</TableCell>
                                            <TableCell>{row.from_location}</TableCell>
                                            <TableCell>{row.to_location}</TableCell>
                                            <TableCell>{row.loading_wt}</TableCell>
                                            <TableCell>{row.received_wt}</TableCell>
                                            <TableCell>{row.shortage_wt}</TableCell>
                                            <TableCell>{row.billing_wt}</TableCell>
                                            <TableCell>{row.freight_rate}</TableCell>
                                            <TableCell>{row.freight_amt}</TableCell>
                                            <TableCell>{row.tds_percent}</TableCell>
                                            <TableCell>{row.tds_amt}</TableCell>
                                            <TableCell>{row.shortage_rate}</TableCell>
                                            <TableCell>{row.shortage_amt}</TableCell>
                                            <TableCell>{row.ad_mines_exp}</TableCell>
                                            <TableCell>{row.ad_diesel_exp}</TableCell>
                                            <TableCell>{row.ad_cash_exp}</TableCell>
                                            <TableCell>{row.total_advance}</TableCell>
                                            <TableCell>{row.commission}</TableCell>
                                            <TableCell>{row.net_amount}</TableCell>
                                            <TableCell>{row.other_exp}</TableCell>
                                            <TableCell>{row.net_payable}</TableCell>
                                            <TableCell>{row.paid_amount}</TableCell>
                                            <TableCell>{row.bal_amount}</TableCell>
                                            <TableCell>
                                                {" "}
                                                {row.billing ? (
                                                    <>
                                                        {row.billing.branch_name === "RAIPUR"
                                                            ? "SRE"
                                                            : row.billing.branch_name === "BILASPUR"
                                                                ? "JHT"
                                                                : "MBR"}
                                                        /{row.billing.billing_id}/
                                                        {getInitials(row.billing.party_name)}
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                            </TableCell>

                                            <TableCell>
                                                {" "}
                                                {row.billing
                                                    ? formatOnlyDate(row.billing.created_at)
                                                    : ""}
                                            </TableCell>

                                            <TableCell>{row.truck_owner}</TableCell>
                                            <TableCell>{row.phone_no}</TableCell>
                                            <TableCell>{row.pan_no}</TableCell>
                                            <TableCell>{row.remark}</TableCell>
                                            <TableCell>{row.created_at}</TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setExcelModalOpen(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleExportSelectedToExcel}>
                        Export Selected
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
